import { h } from 'preact';

export default function PromotionCard({ promo, isApplied, isManuallyEntered, onRemove }) {
  return (
    <div
      className={`
        p-4 border-2 transition-all relative
        ${isApplied
          ? 'bg-coit-red text-white border-coit-red'
          : 'border-gray-200 text-black'
        }
      `}
    >
      <div className="flex justify-between items-center">
        <div className="flex flex-col gap-0">
          <div className="font-semibold">{promo.title}</div>
          {promo.description && <div className="text-sm">{promo.description}</div>}
        </div>

        <div className="flex items-center gap-2">
          {isApplied && (
            <span className="flex items-center gap-1 text-white text-sm font-medium">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                  clipRule="evenodd"
                />
              </svg>
              Applied
            </span>
          )}

          {isManuallyEntered && onRemove && (
            <button
              onClick={() => onRemove(promo.promo_code)}
              className={`p-1 rounded hover:bg-opacity-20 hover:bg-black transition-colors ${
                isApplied ? 'text-white' : 'text-gray-500'
              }`}
              title="Remove promo code"
            >
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
